import React from 'react';
import { Modal } from 'react-bootstrap';

const ConfirmationModal = ({
  show,
  onHide, // Use this consistently
  onConfirm,
  onClose = true,
  title,
  message,
  messageHTML,
  showCancelButton = true,
  messageColor = "#212529",
  size = "",
  onconfirmname = "Yes",
  oncancelname = "No",
  closeButton = true
}) => {
  return (
    <Modal show={show} onHide={onHide} centered size='md' backdrop="static" keyboard={false} >
      <Modal.Header closeButton={closeButton}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
         {messageHTML ? ( 
          <p
            dangerouslySetInnerHTML={{
              __html: messageHTML,
            }}
          />
       ) : ( 
          <h5 style={{ color: messageColor }}>{message}</h5>
        )} 
         
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-success" onClick={onConfirm}>
          {onconfirmname}
        </button>
        {showCancelButton && (
          <button className="btn btn-danger" onClick={onHide}>
            {oncancelname}
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
